<template>
  <div id="Onboard_system">
    <div class="font">
      <span class="introSubTitle"><b>星载遥感轨智能处理系统</b></span>
      <p class="textStyle">联合长光卫星公司研制了我国首个业务化运行的灾害应急响应商业卫星在轨处理系统，创新了星载受限情况下遥感数据实时处理方法，具有森林火点和海面船舶的自动识别、搜寻和定位功能，用户无须经历传统的“上注任务、卫星成像、接收图像、图像处理、信息分析”的漫长过程（传统过程往往需要数小时），实现了从“卫星到用户”由小时级到分钟（秒）级的跨越。</p>
    </div>
   <!-- <br/>   -->
      <img
        width="100%"
        src="@/assets/img/scientific/Star.jpg"
      />
    <p class="img_figure">星上在轨发现与提取森林火点信息分发到地面用户终端共用时13秒</p>
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="less">
#Onboard_system {
  margin-top: 20px;
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
}
</style>
